export default "__VITE_ASSET__VB$sn0n___"